/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { packageByIdQueryOptions } from '@/core/components/sites/site/rates-and-packages/packages/packagesQueryOptions'
import { promoCodeQueryOptions } from '@/core/components/sites/site/rates-and-packages/promo-code/promoCodeQueryOptions'
import { ratesQueryOptions } from '@/core/components/sites/site/rates-and-packages/rates/ratesQueryOptions'
import { cancellationPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/policiesQueryOptions'
import { taxAndFeesPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/taxAndFeesQueryOptions'
import { defer, redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const ratesSearchSchema = z.object({
  search: z.string().catch(''),
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  sortBy: z
    .enum([
      'id',
      'status',
      'code',
      'externalCode',
      'rateCategory',
      'title',
      'type',
      'startSell',
      'endSell',
      'minLeadTime',
      'LOSmin',
    ])
    .catch('code'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/'
)({
  validateSearch: (search) => ratesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({
    context: { queryClient, auth },
    params: { packageId, siteId },
  }) => {
    const packageById = queryClient.ensureQueryData(
      packageByIdQueryOptions(siteId, packageId, auth.token!)
    )
    const rates = defer(
      queryClient.ensureQueryData(ratesQueryOptions(siteId, auth.token!))
    )
    const taxes = defer(
      queryClient.ensureQueryData(
        taxAndFeesPoliciesQueryOptions(siteId, auth.token!)
      )
    )
    const cancelation = defer(
      queryClient.ensureQueryData(
        cancellationPoliciesQueryOptions(siteId, auth.token!)
      )
    )
    const promoCodes = defer(
      queryClient.ensureQueryData(promoCodeQueryOptions(siteId, auth.token!))
    )

    return {
      packageById,
      rates,
      taxes,
      cancelation,
      promoCodes,
    }
  },

  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
